import React from 'react';
import {connect} from 'react-redux';
import {BaseStackSummary} from 'components/organisms/stack-summary/components/sports/lol';
import OptimizeButton from 'components/molecules/optimize-button';

class StackSummaryComponent extends BaseStackSummary {
    render() {
        const {rawLineups} = this.props;
        const groups = this.prepareGroups();
        const lineupsQuantity = rawLineups.getQuantity();
        const teamsQuantity = this.countTeams(groups);

        const content = Object.keys(groups).map((groupNumber) => {
            return this.getTeamsStackView(groupNumber, groups[groupNumber]);
        });

        isEmpty(content) && content.push(this.getNotFoundView());

        return (
            <div className="tab-content stack-summary-content">
                <div className="players-heading">
                    <strong>{teamsQuantity}</strong> Teams Used | <strong>{lineupsQuantity}</strong> Lineups
                    <OptimizeButton />
                </div>
                <div className="players-used-table table-holder">
                    <div className="table-scroll">{content}</div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking, lineupsData, lineupTeamsStacks} = state;

    return {
        rawLineups: lineupsData.rawLineups,
        stacking: randomTeamStacking,
        lineupTeamsStacks,
    };
}

const StackSummary = connect(mapStatesToProps)(StackSummaryComponent);

export {StackSummary};
